import APIService from 'services/APIService'

const api = APIService()

export const getFileCategories = () => api.get('/dictionaries/file-categories')
export const getFolders = () => api.get('/dictionaries/folders')
